// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// // ScrollSmoother requires ScrollTrigger
// import { ScrollSmoother } from 'gsap/ScrollSmoother';

// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export default {
  init() {
    // JavaScript to be fired on all pages

    // ScrollSmoother.create({
    //   smooth: 2,
    //   effects: true,
    // });

    // ARIA fix: Add role="menubar" to menus containing role="menuitem" elements
    document.querySelectorAll('ul:has([role="menuitem"])').forEach(ul => {
      if (!ul.hasAttribute('role')) {
        ul.setAttribute('role', 'menubar');
      }
    });

    // Accessibility fix: Ensure iframe/frame elements have a non-empty title
    document.querySelectorAll('iframe:not([title]), iframe[title=""], frame:not([title]), frame[title=""]').forEach(el => {
      const src = el.getAttribute('src') || '';
      let title = 'Eingebetteter Inhalt';
      if (src.includes('youtube') || src.includes('youtu.be')) {
        title = 'YouTube Video';
      } else if (src.includes('vimeo')) {
        title = 'Vimeo Video';
      } else if (src.includes('google.com/maps') || src.includes('maps.google')) {
        title = 'Google Maps';
      }
      el.setAttribute('title', title);
    });

    var vw = $(window).width();

    if(vw > 992) {
      const navLinks = document.querySelectorAll('#main-nav .nav-link');
      navLinks.forEach(link => {
        const ul = link.nextElementSibling;
        if (!ul || !ul.classList.contains('dropdown-menu')) {
          return;
        }

        const text = link.getAttribute('data-desc');
        if (!text) {
          return;
        }

        const h2 = document.createElement('div');
        h2.classList.add('h4');

        const linkText = link.textContent;
        link.innerHTML = `<span class="">${linkText}</span>`;
        // link.childNodes[0].remove();

        h2.innerText = text;
        ul.insertBefore(h2, ul.firstChild);
      });

      // WCAG 2.2 compliant keyboard navigation for dropdown menus
      this.initAccessibleDropdowns();
    }


    $(window).scroll(function () {



      if ($(this).scrollTop() > 40) {
        $('body').addClass('menu-sticky');
      } else {
        $('body').removeClass('menu-sticky');
      }

      if ($(this).scrollTop() < 40) {
        $('body').addClass('menu-sticky-reverse');
      } else {
        $('body').removeClass('menu-sticky-reverse');
      }

      if ($(this).scrollTop() > 500) {
        $('.termin-btn').addClass('animation-roll');
      } else {
        $('.termin-btn').removeClass('animation-roll');
      }

      const footer = $('.footer-content.footer');
      const scrollBottom = $(this).scrollTop() + $(this).height();
      const footerTop = footer.length ? footer.offset().top : Number.POSITIVE_INFINITY;
      const isAtFooter = scrollBottom >= footerTop;
      const kite = $('.kite-wrapper.kite-left-bottom');
      const termin = $('.termin-wrapper');
      const terminBtn = $('.termin');
      if (isAtFooter) {
        if (terminBtn.is(':visible')) terminBtn.fadeOut(300);
        if (kite.is(':visible')) kite.fadeOut(300);
        if (termin.is(':visible')) termin.fadeOut(300);
      } else {
        if (!terminBtn.is(':visible')) terminBtn.fadeIn(300);
        if (!kite.is(':visible')) kite.fadeIn(300);
        if (!termin.is(':visible')) termin.fadeIn(300);
      }
    });






    // Modal

    $('#modal').on('show.bs.modal', function (event) {
      var button = $(event.relatedTarget) // Button that triggered the modal


      var content = button.data('content'),
        link = button.attr('href'), // Extract info from data-* attributes
        text = button.data('text');

      if (content && text && link) {

        // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
        var modal = $(this)
        console.log(modal.find('.modal-content'));

        modal.find('.modal-content').html('<a href="' + link + ' ">' + content + '</a>');
        modal.find('.modal-text').text(text);
      } else {
        $(this).find('.modal-body').load(button.attr('href') + ' #sb_instagram', function () {
          $.getScript('/kapelari/Projekte/rja_wp/wp-content/plugins/instagram-feed/js/sbi-scripts.min.js?ver=2.5.4');
        });
        //http://localhost:8888/kapelari/Projekte/rja_wp/wp-content/plugins/instagram-feed/js/sbi-scripts.min.js?ver=2.5.4

        // sbi_init();


      }

    })

    // Kontakt Page

    if ($('body').hasClass('page-kontakt-data')) {

      $('.header-content').addClass('contact-setting');
    }

    // mobile-nav
    $('.navbar-toggler-icon').click(function () {

      $('body').toggleClass('menu-open');
    })

  }, // close init

  /**
   * Initialize accessible keyboard navigation for dropdown menus
   * WCAG 2.2 compliant - supports Tab, Escape, and Arrow keys
   */
  initAccessibleDropdowns() {
    const menuItems = document.querySelectorAll('#main-nav .menu-item-has-children');

    menuItems.forEach(menuItem => {
      const trigger = menuItem.querySelector('.nav-link');
      const dropdown = menuItem.querySelector('.dropdown-menu');
      const dropdownLinks = dropdown ? dropdown.querySelectorAll('.dropdown-item') : [];

      if (!trigger || !dropdown) return;

      // Track if dropdown is open
      let isOpen = false;

      // Open dropdown on focus (Tab key)
      trigger.addEventListener('focus', () => {
        this.openDropdown(menuItem, trigger, dropdown);
        isOpen = true;
      });

      // Close dropdown when tabbing away from trigger (backward navigation)
      trigger.addEventListener('blur', () => {
        setTimeout(() => {
          if (!menuItem.contains(document.activeElement)) {
            this.closeDropdown(menuItem, trigger, dropdown);
            isOpen = false;
          }
        }, 10);
      });

      // Open dropdown on mouse enter (existing behavior)
      menuItem.addEventListener('mouseenter', () => {
        this.openDropdown(menuItem, trigger, dropdown);
        isOpen = true;
      });

      // Close dropdown on mouse leave (existing behavior)
      menuItem.addEventListener('mouseleave', () => {
        this.closeDropdown(menuItem, trigger, dropdown);
        isOpen = false;
      });

      // Handle keyboard events on trigger
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen) {
          this.closeDropdown(menuItem, trigger, dropdown);
          trigger.focus();
          isOpen = false;
          e.preventDefault();
        }
      });

      // Handle keyboard navigation within dropdown
      dropdownLinks.forEach((link, index) => {
        link.addEventListener('keydown', (e) => {
          // Escape key - close dropdown and return focus
          if (e.key === 'Escape') {
            this.closeDropdown(menuItem, trigger, dropdown);
            trigger.focus();
            isOpen = false;
            e.preventDefault();
          }

          // Arrow Down - move to next item
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            const nextLink = dropdownLinks[index + 1];
            if (nextLink) {
              nextLink.focus();
            }
          }

          // Arrow Up - move to previous item
          if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevLink = dropdownLinks[index - 1];
            if (prevLink) {
              prevLink.focus();
            } else {
              trigger.focus();
            }
          }
        });

        // Keep dropdown open when focusing dropdown items
        link.addEventListener('focus', () => {
          this.openDropdown(menuItem, trigger, dropdown);
          isOpen = true;
        });

        // Close dropdown when tabbing out of last item
        link.addEventListener('blur', () => {
          setTimeout(() => {
            if (!menuItem.contains(document.activeElement)) {
              this.closeDropdown(menuItem, trigger, dropdown);
              isOpen = false;
            }
          }, 10);
        });
      });
    });
  },

  /**
   * Open dropdown menu
   */
  openDropdown(menuItem, trigger, dropdown) {
    dropdown.style.display = 'block';
    trigger.setAttribute('aria-expanded', 'true');
    menuItem.classList.add('show');
  },

  /**
   * Close dropdown menu
   */
  closeDropdown(menuItem, trigger, dropdown) {
    dropdown.style.display = 'none';
    trigger.setAttribute('aria-expanded', 'false');
    menuItem.classList.remove('show');
  },


  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // var Instafeed = require('instafeed');

    // Add Class Menu-Sticky wenn Scroll höhe ist über 40
    var scrollHeight = $('html').scrollTop();
    if (scrollHeight > 40) {
      $('body').addClass('menu-sticky');
    }


    // Mobile Nav
    var vw = $(window).width();

    $('[data-toggle="offcanvas"]').on('click', function () {
      $('.offcanvas-collapse').toggleClass('open')
    });

    if (vw < 992) {
      // Mobile menu
      $('.offcanvas-collapse .menu-item-has-children > a').on('click', function (e) {
        e.preventDefault(); // event unterdrücken
        // console.log('click');
        $('.offcanvas-collapse .dropdown-menu').collapse('hide');
        $(this).siblings('.dropdown-menu').collapse('toggle');

        $('.dropdown-menu a').on('click', function () {
          $('#main-nav').removeClass('open');
          $('body').removeClass('menu-open');
          // console.log($(this));

        })
      })
    }

    // Kontaktform Checkboxen
    $('.licences').hide();
    $('input[name=fuehrerscheine-true]').click(function () {
      $(this).val() == 'Ja' ? $('.licences').show() : $(this).val() == 'Nein' && $('.licences').hide()
    });


    // Fill modal with content from link href
    $('#modal').on('show.bs.modal', function (e) {
      var link = $(e.relatedTarget);
      $(this).find('.modal-body').load(link.attr('href') + ' #main-content');
    });

    // Paroller nur auf Desktop aktivieren - springt auf Touch-Geräten
    if ($(window).width() >= 992) {
      require('paroller.js');
      setTimeout(function () {
        $('.paroller').paroller({
          factor: 0.15,
          type: 'foreground',
          direction: 'vertical',
          transition: 'transform 0.3s ease-out',
        });
      }, 1000);
    }
  },

};

$(document).on('click', '[data-toggle="lightbox"]', function(event) {
  event.preventDefault();
  $(this).ekkoLightbox();
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js